import { useHistory } from "react-router-dom";

import logo from "../../../Assets/applifecycle/appicon-placeholder.svg";
import styles from "./PendingAppCard.module.scss";
import { sliceString } from "../../../util/helpers/funcHelper";
import { AuthImage } from "../../common/AuthImage";
const PendingAppCard = ({ data }) => {
  const history = useHistory();
  return (
    <div
      onClick={() =>
        history.push(`/console/${data.projectId}/${data.id}`)
      }
      className={styles.appcard}
    >
      <div className={styles.headingcontainer}>
        <AuthImage
          src={data.graphics?.appIcon?.url}
          fallback={logo}
          alt="applogo"
        />
        <h4>{sliceString(0,19,data.title,true)}</h4>
      </div>
      <span className="">
        {/* <span className="">Project: {data.projectName}</span> */}
        <span className="">Submitted on: {data?.created_at}</span>
      </span>
      <div className={styles.statuscontainer}></div>
    </div>
  );
};

export default PendingAppCard;
